import Vue from 'vue'
import Vuex from 'vuex'

import defaults from './defaults'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import auth from './auth'
import workplace from './workplace'
import analytics from './analytics'
import objects from './objects'
import modeling from './modeling'
import technologies from './technologies'
import priorities from './priorities'
import infrastructures from './infrastructures'
import markerLayers from './markerLayers'
import documents from './documents'
import zonegroups from './zonegroups'
import excelLayers from './excel-layers'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: defaults,
  actions,
  mutations,
  getters,
  modules: {
    auth,
    workplace,
    analytics,
    objects,
    modeling,
    priorities,
    infrastructures,
    technologies,
    markerLayers,
    zonegroups,
    documents,
    excelLayers,
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js